import { createFileRoute } from "@tanstack/react-router";
import { ariVerificationShortRoute } from "@/features/ari-verification";

export const Route = createFileRoute("/ari/verify/$id")({
    ...ariVerificationShortRoute,
});
